// extracted by mini-css-extract-plugin
export default {"nameColumn":"cBu96","nameContainer":"LsZsC","row":"Til7G","total":"fTpOJ","overflow":"_0UIFp","tooltip":"RqAws","divider":"olBAl"};